var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "guid",
    title: "GUID",
    description: "A GUID in standard format with dashes or stripped format without dashes.",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validStandard: {
            must: true,
            run: function () {
                return validate({}, "550e8400-e29b-41d4-a716-446655440000");
            }
        },
        validCompact: {
            must: true,
            run: function () {
                return validate({}, "550e8400e29b41d4a716446655440000");
            }
        },
        invalidShort: {
            throw: "fields.guid.invalid",
            run: function () {
                return validate({}, "550e84");
            }
        },
        invalidNonHex: {
            throw: "fields.guid.invalid",
            run: function () {
                return validate({}, "550e8400-e29b-41d4-a716-zzzzzzzzzzzz");
            }
        },
        invalidFormat: {
            throw: "fields.guid.invalid",
            run: function () {
                return validate({}, "550e8400/e29b-41d4-a716-446655440000");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid GUID Format",
            description: "Must be a valid 32-character hexadecimal string with or without dashes.",
            template: "'${value}' is not a valid GUID."
        }
    }
});

function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ value: value });
    }

    // Standard format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
    var dashPattern = /^(?:\{{0,1}(?:[0-9a-fA-F]){8}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){4}-(?:[0-9a-fA-F]){12}\}{0,1})$/i;

    // Compact format: 32 hex characters, no dashes
    var compactPattern = /^[0-9a-f]{32}$/i;

    if (dashPattern.test(value) || compactPattern.test(value)) {
        return;
    }

    _.errors.invalid.throw({ value: value });
}
module.exports.validate = validate;
